module.exports = __webpack_public_path__ + "media/images/crypto/bcc-97c10cfb80955b928031e0514a2dd0f8.png";